import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef } from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {CalendarNewsService} from '../../../service/calendar/service-calendarnews';
import {CalendarNewsFileService} from '../../../service/calendar/service-calendarnewsfile';
import {CalendarNewsFile} from '../../../models/calendar/calendarnewsfile';
import {CalendarNews} from '../../../models/calendar/calendarnews';
import {CommandUtil} from '../../../global/commandutil';
import {CalendarNewStaffsService} from '../../../service/calendar/service-calendarnewstaffs';
import {CalendarNewStaffs} from '../../../models/calendar/calendarnewstaffs';
import {Sessioncommand} from '../../../global/sessioncommand';
@Component({
  templateUrl: './readlichcongtac.component.html'

})
export class ReadLichCongTacComponent implements OnInit, AfterViewInit {

  public language = language;
  public id: number = 0;
  public isEdit: boolean = false;
  public fileLists: CalendarNewsFile[] = [];
  public tuNgay: Date = new Date();
  public denNgay: Date = new Date();
  public thongBao: CalendarNews = new CalendarNews();
  public onClose: Subject<boolean>;
  public calendarNewStaffs: CalendarNewStaffs=new CalendarNewStaffs();
  constructor( public calendarNewsService: CalendarNewsService,
               public toastr: ToastrService,
               public calendarNewsFileService: CalendarNewsFileService,
               public _bsModalRef: BsModalRef,
               public datePipe: DatePipe,
               public commandUtil: CommandUtil,
               public calendarNewStaffsService: CalendarNewStaffsService
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }

  public edit(id: number) {
    this.id= id;
    this.isEdit = true;
    this.calendarNewsService.getById(id).pipe(first())
      .subscribe(x => {
        this.thongBao = x;
        if (id != 0) {
          this.tuNgay = new Date(this.datePipe.transform(x.tuNgay, 'yyyy-MM-dd'));
          this.denNgay = new Date(this.datePipe.transform(x.denNgay, 'yyyy-MM-dd'));
          this.calendarNewStaffs.calendarNewId = id;
          this.calendarNewStaffs.staffId = Sessioncommand.staffId;
          this.calendarNewStaffsService.add(this.calendarNewStaffs).subscribe(
            {
              next: (data) => {
              },
              error: error => {
              }
            });
        }

      });

    this.calendarNewsFileService.findAllByCalendarId(id).subscribe(
      x => {
        this.fileLists = x;
      });


  }


  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

